export { default as Topics } from './Topics';
